import React, { useState } from "react";
import styles from "./MammalChampion.module.scss";

function Username(props) {
  const [value, setValue] = React.useState(
    localStorage.getItem("factWhatIfUsername") || ""
  );
  const [submitted, setSubmitted] = React.useState(false);

  const onChange = (event) => setValue(event.target.value);
  const onSubmit = (event) => {
    localStorage.setItem("factWhatIfUsername", value);
    setSubmitted(true);
  };

  if (localStorage.getItem("factWhatIfUsername") === "") {
    return (
      <div className={styles.bkg}>
        <div className={styles.usernameOptions}>
          <p>
            If you would like to enter the site with a username or handle, you
            can easily find any submissions you make later! However, this
            username will be saved in your local storage and onto our database,
            so make sure not to use any sensitive or personal information when
            selecting it!
          </p>

          <p>
            Username:{" "}
            <input
              className={styles.usernameInput}
              value={value}
              type="text"
              onChange={onChange}
            />
            <button className={styles.choice} onClick={onSubmit}>
              Submit
            </button>
          </p>

          <p>
            Or, if you don't want to add a username, feel free to continue
            without one!
          </p>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <p>Welcome back, {value}!</p>

        <button
          className={styles.choice}
          onClick={(e) => {
            setSubmitted(false);
            setValue("");
            localStorage.setItem("factWhatIfUsername", "");
          }}
        >
          That's not my name!
        </button>
      </>
    );
  }
}

export default Username;
